import React, { ReactNode } from 'react';

import { TriangleDownIcon } from '@modernloop/shared/icons';
import { Button } from '@mui/material';

interface FilterButtonProps {
  hasSelections: boolean;
  onClick: () => void;
  children: ReactNode;
  dataTestId?: string;
  disabled?: boolean;
  startIcon?: ReactNode;
}

/**
 * A standardized button for filter dropdowns.
 * Provides consistent styling across all filter components.
 */
const FilterButton = (
  { hasSelections, onClick, children, dataTestId, disabled = false, startIcon }: FilterButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) => {
  return (
    <Button
      ref={ref}
      size="small"
      color={hasSelections ? 'info' : undefined}
      startIcon={startIcon}
      endIcon={<TriangleDownIcon />}
      onClick={onClick}
      data-testid={dataTestId}
      disabled={disabled}
      sx={{ '& .MuiButton-endIcon': { ml: 0.5, mt: -0.25 } }}
    >
      {children}
    </Button>
  );
};

FilterButton.displayName = 'FilterButton';

export default React.forwardRef<HTMLButtonElement, FilterButtonProps>(FilterButton);
